export const sendNavigationMessageToParent = (
  direction: 'next' | 'back' | 'restart'
) => {
  if (!window.parent) {
    return;
  }

  window.parent.postMessage(
    {
      type: 'tour_navigation',
      payload: { direction },
    },
    '*'
  );
};
